import { QueryObserver, QueryObserverOptions } from '@tanstack/query-core';

import { fetchPerformanceDashboards } from '../../predict/src/core/api/reporting/performance-dashboards';
import { queryClient } from '../core/queryClient';

type FetchPerformanceDashboardsResult = Awaited<ReturnType<typeof fetchPerformanceDashboards>>;
type PerformanceDashboardsQueryOptions = Omit<
  QueryObserverOptions<FetchPerformanceDashboardsResult>,
  'queryKey' | 'queryFn'
>;

export const performanceDashboardsQueryKey = (organisationId: string, workspaceId: string) => [
  'performanceDashboards',
  organisationId,
  workspaceId
];

export const performanceDashboardsQuery = (
  workspaceId: string,
  organisationId: string,
  options?: PerformanceDashboardsQueryOptions
): QueryObserver<FetchPerformanceDashboardsResult> =>
  new QueryObserver<FetchPerformanceDashboardsResult>(queryClient, {
    queryKey: performanceDashboardsQueryKey(organisationId, workspaceId),
    queryFn: () => fetchPerformanceDashboards(workspaceId, organisationId),
    ...options
  });
